import React, { useState } from 'react'
import { Row, Col, Button, Modal, Form } from 'react-bootstrap';
import { getItem, setItem } from '../../config/localStorage';

function PersonalDetails(props) {
    const getPersonalDetailsData = JSON.parse(getItem('personalDetailsData'));
    const [personalDetails, setPersonalDetails] = useState({
        'dob': getPersonalDetailsData !== null ? getPersonalDetailsData.dob : '',
        'nationality': getPersonalDetailsData !== null ? getPersonalDetailsData.nationality : '',
        'maritalStatus': getPersonalDetailsData !== null ? getPersonalDetailsData.maritalStatus : '',
    });
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [dob, setDob] = useState(personalDetails.dob);
    const [nationality, setNationality] = useState(personalDetails.nationality)
    const [maritalStatus, setMaritalStatus] = useState(personalDetails.maritalStatus)
    const {setPersonalCheckbox,...rest} = props

    const handleUserDetails = (e) => {
        const fieldName = e.target.name
        setError('')
        setSuccess('');
        
        let regName = /^[a-zA-Z]*$/;
        if (fieldName === "pd-nationality") {
            if (!regName.test(e.target.value)) {
                return;
            }
            setNationality(e.target.value)
        }

        if (fieldName === "pd-marital-status") {
            if (!regName.test(e.target.value)) {
                return;
            }
            setMaritalStatus(e.target.value)
        }

        if(fieldName === "pd-dob"){
            setDob(e.target.value)
        }
    }

    const personalDetailsInfo = (e) => {
        e.preventDefault();
        setError('');
        setSuccess('')

        const formattedData = {
            'dob': dob,
            'nationality': nationality,
            'maritalStatus': maritalStatus
        };

        setPersonalDetails(formattedData);

        setSuccess('Thank you for providing your personal details.');

        if (getItem('personalDetails') !== null) {
            setPersonalDetails(formattedData);
            setItem('personalDetailsData', JSON.stringify(formattedData));
        }

    }

    const closePopUp = () => {
        setSuccess('')
        setError('')
    };

    function subtractYears(date, years) {
        date.setFullYear(date.getFullYear() - years);
        return date;
    }
    
    const date = new Date();
    const newDate = subtractYears(date, 14);

    return (
        <>
            <Modal
                {...rest}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop='static'
            >
                <Modal.Header closeButton variant="secondary" onClick={closePopUp}>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Personal Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={personalDetailsInfo} id="personalDetailFileds">
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Date of Birth / Age</Form.Label>
                                    <Form.Control type="date" pattern="\d{2}-\d{2}-\d{4}" max={newDate.toISOString().split('T')[0]} name="pd-dob" format="mm/dd/yyyy" defaultValue={personalDetails.dob} onChange={(e) => handleUserDetails(e)} />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Label>Nationality</Form.Label>
                                    <Form.Control type="text" name="pd-nationality" value={nationality} onChange={(e) => handleUserDetails(e)} />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Label>Marital Status</Form.Label>
                                    <Form.Control type="text" name='pd-marital-status' value={maritalStatus} onChange={(e) => handleUserDetails(e)} />
                                </Form.Group>
                            </Col>

                            {
                                error != '' ?
                                    <Col md={12}>
                                        <div className="alert alert-danger" role="alert">
                                            {error}
                                        </div>
                                    </Col>
                                    : ''
                            }

                            {
                                success != '' ?
                                    <Col md={12}>
                                        <div className="alert alert-success" role="alert">
                                            {success}
                                        </div>
                                    </Col>
                                    : ''
                            }

                            <Modal.Footer>
                                <Button className='button-green' type="submit">Save changes</Button>
                            </Modal.Footer>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal >
        </>
    )
}

export default PersonalDetails
